import axios from "axios";
import store from "../store/store";
import { currentLocale } from "../i18n";

const rawApi = (process.env.REACT_APP_API_URL || "").trim();
export const API_BASE = rawApi.replace(/\/*$/, "/");

// The oauth endpoints live OUTSIDE the /api/ prefix:
//   API_BASE   = https://dev-test.hajexbolt.com/ship_api/public/api/
//   OAUTH_BASE = https://dev-test.hajexbolt.com/ship_api/public/oauth/
// The leading slash in the pattern matters: without it a base ending in a
// segment such as /myapi/ would be mangled.
const derived = API_BASE.replace(/\/api\/?$/, "/oauth/");
const fromEnv = (process.env.REACT_APP_OAUTH_URL || "").trim();
export const OAUTH_BASE = (fromEnv || derived).replace(/\/*$/, "/");

// Deliberately NO baseURL: call sites pass absolute URLs, because the login
// endpoint and the oauth endpoints sit on two different bases.
//
// Deliberately NO response interceptor. The shared axiosInstance clears
// localStorage and hard-navigates to /Login on ANY 401, which would destroy an
// in-flight authorization request -- on a single mistyped password, or on an
// expired token at the moment the user clicks "switch account". A navigation
// cannot be caught, so avoiding the interceptor is the only real fix.
const oauthAxios = axios.create({
  timeout: 25000,
  headers: { Accept: "application/json" },
});

oauthAxios.interceptors.request.use((config) => {
  config.headers["Accept-Language"] = currentLocale();
  const token = store.getState()?.user?.token || localStorage.getItem("Token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    // DELETE the key rather than assigning undefined: axios 0.27's xhr adapter
    // iterates headers and calls setRequestHeader without filtering, so the
    // request would go out with the literal string "undefined".
    delete config.headers.Authorization;
  }
  return config;
});

export default oauthAxios;
